import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService } from 'src/app/services/common/common.service'
import { AppState } from 'src/app/store/state/app.state'
import { getEnabledModules } from 'src/app/store/selector/company-settings.selector'

@Component({
  selector: 'app-repository-quick-select',
  templateUrl: './data-repository-quick-select.component.html',
  styleUrls: ['./data-repository-quick-select.component.scss']
})
export class DataRepositoryQuickSelectComponent implements OnInit {
  filteredQuickSelectOptions$: Observable<any[]>

  constructor(
    private cs: CommonService,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.filteredQuickSelectOptions$ = this.store.select(getEnabledModules).pipe(
      map(enabledModules =>
        GlobalConstants.DATA_REPO_QUICK_SELECT_OPTIONS.filter(
          opt => !(opt as any).module || enabledModules.includes((opt as any).module)
        )
      )
    )
  }

  navigateToSummaryPage(id: number) {
    const summaryPage = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${id}/${GlobalConstants.ROUTING.SUMMARY}`
    this.cs.route(summaryPage)
  }
}
